<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5>Viviendas</h5>
			<p-table
				#dt1
				[value]="housings"
				dataKey="id"
				[rows]="10"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="['name', 'price']"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button 
							    *ngIf="getUser().role_id == 1"
								pButton
								pTooltip="Nueva vivienda"
								class="p-button-raised p-button-outlined m-1"
								icon="pi pi-plus"
								(click)="showDialog()"
							></button>
							<button
								pButton
								pRipple
								label="Actualizar"
								pTooltip="Actualizar viviendas"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadHousing(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center" pSortableColumn="user.name" 
						*ngIf="getUser().role_id == 1">
							<p-sortIcon field="user.name"></p-sortIcon>
							Cliente
						</th>
						<th class="text-center" pSortableColumn="title">
							<p-sortIcon field="title"></p-sortIcon>
							Nombre
						</th>
						<th class="text-center" pSortableColumn="address">
							<p-sortIcon field="address"></p-sortIcon>
							Dirección
						</th>
						<th class="text-center" pSortableColumn="size">
							<p-sortIcon field="size"></p-sortIcon>
							Tamaño
						</th>
						<th class="text-center">
							Tarifas
						</th>
						<th *ngIf="getUser().role_id == 1">
							Trabajadores
						</th>
						<th *ngIf="getUser().role_id == 1"></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-housing>
					<tr>
						<td class="text-center" style="min-width: 5rem" *ngIf="getUser().role_id == 1">
							<div class="circle-color circle-color-small" [style.background]="'#'+housing.user.color"></div>
							{{ housing.user.name }} {{ housing.user.surname }}<br><small>{{ housing.user.email }}</small>
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ housing.title }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ housing.address }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ housing.size > 0 ?  housing.size + ' m²' : '' }}
						</td>
						<td style="font-size:12px;">
							<h6 class="mb-0 fw-bold" *ngIf="housing.services.length > 0">Servicios</h6>
							<label *ngFor="let hService of housing.services">
								{{hService.quantity}} x {{hService.service.name}} - {{hService.price | currency: 'EUR' }} <br>
							</label>
							<h6 class="mb-0 fw-bold" *ngIf="housing.extras.length > 0">Extras</h6>
							<label *ngFor="let hExtras of housing.extras">
								{{hExtras.quantity}}  {{hExtras.extra.name}} - {{hExtras.price | currency: 'EUR' }} <br>
							</label>
						</td>
						<td class="text-left" style="min-width: 1rem" 
						*ngIf="getUser().role_id == 1 && workersData.length > 0">
							<ol>
								<li *ngFor="let worker of housing.workers">
									{{workersData[worker.user_id] ? workersData[worker.user_id].name_surname : ''}}<br>
								</li>
							</ol>
						</td>
						<td class="text-center" style="min-width: 1rem" 
						*ngIf="getUser().role_id == 1">
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Eliminar vivienda"
								icon="pi pi-trash"
								class="p-button-danger p-button-raised p-button-outlined m-1"
								(click)="deleteHousing(housing)"
							></button>
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Editar vivienda"
								icon="pi pi-pencil"
								class="p-button-raised p-button-outlined m-1"
								(click)="showDialog(housing)"
							></button>
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando viviendas...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<!-- Modal para creación/edición vivienda -->
<p-dialog
	header="Datos del vivienda"
	[(visible)]="dialogHousing"
	[modal]="true"
	[style]="{ width: '80vw' }"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
>
	<form [formGroup]="form">
		<div class="grid p-fluid mt-3">
			<div class="field col-12 md:col-4">
				<label for="services">Cliente</label>
				<p-dropdown
					[style]="{ width: '100%' }"
					placeholder="Seleccione un tipo"
					optionLabel="name_surname_email"
					optionValue="id"
					formControlName="user_id"
					appendTo="body"
					[options]="users">
				</p-dropdown>
			</div>

			<div class="field col-12 md:col-8">
				<label>Titulo *</label>
				<input
					type="text"
					formControlName="title"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('title')!.errors &&
						form.get('title')!.touched &&
						form.get('title')!.hasError('required')
					"
					>Requerido</small
				>
			</div>
			<div class="field col-12 md:col-4">
				<label>Tamaño (m²)</label>
				<p-inputNumber formControlName="size"> </p-inputNumber>
				<small
					class="p-error"
					*ngIf="
						form.get('size')!.errors &&
						form.get('size')!.touched &&
						form.get('size')!.hasError('required')
					"
					>Requerido</small
				>
			</div>
			<div class="field col-12 md:col-8">
				<label>Dirección *</label>
				<input
					type="text"
					formControlName="address"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('address')!.errors &&
						form.get('address')!.touched &&
						form.get('address')!.hasError('required')
					"
					>Requerido</small
				>
			</div>
			
			<div class="field col-12 md:col-12" *ngIf="getUser().role_id == 1">
				<label for="services">Trabajadores Asignados</label>
				<p-multiSelect
					[style]="{ width: '100%' }"
					placeholder="Seleccione trabajadores"
					optionLabel="name_surname_email"
					optionValue="id"
					formControlName="workers"
					appendTo="body"
					[options]="workers">
				</p-multiSelect>
			</div>

			<div class="field col-12 md:col-8 md:col-offset-2">
				<h4>Servicios</h4>
				<p-table
					dataKey="id"
					[loading]="loading"
					[rowHover]="true"
					[paginator]="false"
					[value]="services">
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 3%;">Activo</th>
							<th style="width: 10%;">Cantidad</th>
							<th style="width: 47%;">Servicio</th>
							<th style="width: 20%;">Por defecto</th>
							<th style="width: 20%;">Precio €</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-service let-rowIndex="rowIndex">
						<tr>
							<td>
								<p-checkbox
								  binary="true"
								  [formControl]="servicesArray.at(rowIndex).get('active')">
								</p-checkbox>
							</td>
							<td>
								<p-inputNumber
									[formControl]="servicesArray.at(rowIndex).get('quantity')">
								</p-inputNumber>
							</td>
							<td>{{ service.name }}</td>
							<td>{{ service.price| currency: 'EUR' }}</td>
							<td>
								<p-inputNumber
								[formControl]="servicesArray.at(rowIndex).get('price')"
								mode="decimal"
								thousandSeparator="."
								decimalSeparator=","
								[minFractionDigits]="2"
								[maxFractionDigits]="2"
								placeholder="1.234,56"
								></p-inputNumber>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
			<div class="field col-12 md:col-8 md:col-offset-2">
				<h4>Extras</h4>
				<p-table
					dataKey="id"
					[loading]="loading"
					[rowHover]="true"
					[paginator]="false"
					[value]="extras">
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 3%;">Activo</th>
							<th style="width: 10%;">Cantidad</th>
							<th style="width: 47%;">Extras</th>
							<th style="width: 20%;">Por defecto</th>
							<th style="width: 20%;">Precio €</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-extra let-rowIndex="rowIndex">
						<tr>
							<td>
								<p-checkbox
								binary="true"
								[formControl]="extrasArray.at(rowIndex).get('active')">
								</p-checkbox>
							</td>
							<td>
								<p-inputNumber
									[formControl]="extrasArray.at(rowIndex).get('quantity')">
								</p-inputNumber>
							</td>
							<td>{{ extra.name }}</td>
							<td>{{ extra.price| currency: 'EUR' }}</td>
							<td>
								<p-inputNumber
								[formControl]="extrasArray.at(rowIndex).get('price')"
								mode="decimal"
								thousandSeparator="."
								decimalSeparator=","
								[minFractionDigits]="2"
								[maxFractionDigits]="2"
								placeholder="1.234,56"
								></p-inputNumber>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</form>
	<ng-template pTemplate="footer">
		<div class="flex justify-content-end col-12">
			<p-button
				styleClass="p-button-rounded"
				[label]="mode === 'register' ? 'Guardar' : 'Actualizar'"
				(click)="registerHousing()"
				[loading]="loading"
			>
			</p-button>
		</div>
	</ng-template>
</p-dialog>
